import { render, staticRenderFns } from "./DevMaintainceTaskList.vue?vue&type=template&id=3f58fb88&scoped=true&"
import script from "./DevMaintainceTaskList.vue?vue&type=script&lang=js&"
export * from "./DevMaintainceTaskList.vue?vue&type=script&lang=js&"
import style0 from "./DevMaintainceTaskList.vue?vue&type=style&index=0&id=3f58fb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f58fb88",
  null
  
)

export default component.exports